var TreeEdit = (function () {
    function TreeEdit() {
    }
    // idea is to copy everything, then clear copied values:
    // - ids
    // - amounts
    // - leave one line item per part number
    // copyFromItem should be a deep copy of an original item that we copy
    TreeEdit.addChild = function (item, parent) {
        var newItem = angular.copy(item);
        switch (item.type) {
            case 'drpg': {
                newItem = this.clearDrpg(newItem);
                parent.item.drpgs.unshift(newItem);
                break;
            }
            case 'partNumber': {
                newItem = this.clearPartNumber(newItem);
                parent.item.partNumbers.unshift(newItem);
                break;
            }
            case 'lineItem': {
                newItem = this.clearLineItem(newItem);
                parent.item.lineItems.unshift(newItem);
                break;
            }
        }
    };
    TreeEdit.clearLineItem = function (lineItem) {
        lineItem.id = '';
        lineItem.extendedPrice = 0;
        for (var _i = 0, _a = lineItem.bonuses; _i < _a.length; _i++) {
            var bonus = _a[_i];
            bonus.amount = 0;
        }
        return lineItem;
    };
    TreeEdit.clearPartNumber = function (partNumber) {
        partNumber.id = '';
        // copy only the first line item
        var lineItem = this.clearLineItem(partNumber.lineItems[0]);
        partNumber.lineItems = [lineItem];
        return partNumber;
    };
    TreeEdit.clearDrpg = function (drpg) {
        drpg.id = '';
        for (var _i = 0, _a = drpg.partNumbers; _i < _a.length; _i++) {
            var partNumber = _a[_i];
            this.clearPartNumber(partNumber);
        }
        return drpg;
    };
    return TreeEdit;
}());

//# sourceMappingURL=treeEdit.js.map
